export default __webpack_public_path__ + "static/147-9dad73055fb9a8732bf3820df5740856.jpg";